module.exports = ".wrapper {\n  width: calc(100% - 230px);\n  height: 100%;\n  padding-top: 50px;\n  margin-left: 230px; }\n"